import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import LabOffering from "@/pages/LabOffering";

export const Route = createFileRoute("/zh-cn/services/lab-services/cleaning-validation")({
  head: () => buildRouteHead("/zh-cn/services/lab-services/cleaning-validation"),
  component: LabOffering,
});

